import React from 'react';
import MultipleLeverMenu from './MultipleLeverMenu.jsx';
import {browserHistory} from 'react-router';
import Profile from './Profile.jsx';
import Hotline from './HotLine.jsx';
import Logo from './Logo.jsx';
// import Notification from './Notification.jsx';
import NotificationTTT from 'modules/thanh-tra-trung/NotificationTTT.jsx'
import {CheckPermission} from 'modules/login/CheckPermission';
import { User } from 'api';
import cookie from 'react-cookie';
import { ShowIf } from 'components/utils';
import classnames from 'classnames';

class Header extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      thanhTraThanhPhoId: ''
    };
  }

  changePage(pageName) {
    browserHistory.push(pageName);
  }
  handleMouseClick() {
    if (cookie.load('accessToken') && window.CALL_API == false ) {
      window.CALL_API = true;
      setTimeout(() => {
        window.CALL_API = false;
      }, 180000);
      User.actions.updateSession.request();
    }
  }

  componentDidMount() {
    this.checkDonVi();
  }

  componentWillReceiveProps() {
    this.checkDonVi();
  }

  checkDonVi() {
    let ThamSo = localStorage.getItem('thamSo') ? JSON.parse(localStorage.getItem('thamSo')) : [];
    let thanhTraThanhPhoId = ThamSo.filter(item => item.ten == 'CQQL_THANH_TRA_THANH_PHO');
    this.setState({thanhTraThanhPhoId: thanhTraThanhPhoId.length ? thanhTraThanhPhoId[0].giaTri : ''});
  }

  render() {
    return (
      // <div className={`header-container ${this.props.routerName === 'congDanTraCuu' || CheckPermission('GIAM_SAT_TRA_CUU_LIETKE') ? 'tc' : ''}`}>
      <div className={classnames('header-container', {'tc': this.props.routerName === 'congDanTraCuu' || CheckPermission('GIAM_SAT_TRA_CUU_LIETKE')})}>
        <div className="header">
          <div className="center">
            <div className="wrap-header-top">
              <Logo/>
              <div>
                <div className={`wrap-content-header ${this.props.routerName == 'congDanTraCuu' ? 'tc' : ''}`}>
                  <Hotline routerName={this.props.routerName}/>
                  {/* {
                    this.props.routerName != 'congDanTraCuu' ?
                      <Notification/>
                    : null
                  } */}
                  {
                    this.props.routerName !== 'congDanTraCuu' &&
                    <NotificationTTT/>
                  }
                  {
                    this.props.routerName !== 'congDanTraCuu' &&
                    <Profile/>
                  }

                </div>
                {
                  this.props.routerName !== 'congDanTraCuu' &&
                  <div className="mt40" onMouseUp={this.handleMouseClick.bind(this)}>
                    <ShowIf condition={CheckPermission('XULYDON_LIETKE')}>
                      <button type="button" className="tc-bt small" onClick={this.changePage.bind(this, '/can-bo-tra-cuu')}><span>Tra cứu đơn</span></button>
                    </ShowIf>
                    <button type="button" className="tc-bt help small mr10" onClick={this.changePage.bind(this, '/huong-dan-su-dung')}><span>Hướng dẫn sử dụng</span></button>
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
        {
          this.props.routerName !== 'congDanTraCuu' && !CheckPermission('GIAM_SAT_TRA_CUU_LIETKE') ?
            <div className="menu-container" onMouseUp={this.handleMouseClick.bind(this)} >
              <div className="center">
                <MultipleLeverMenu routerName={this.props.routerName} thanhTraThanhPhoId={this.state.thanhTraThanhPhoId} />
              </div>
            </div>
          :''
        }
      </div>
    );
  }
}
export default Header;



// WEBPACK FOOTER //
// ./src/components/layout/partials/Header.jsx